<template>
  <validation-provider
    :rules="_rules"
    :name="columnInfo.label"
    v-slot="{ validated, touched, passed, errors }"
  >
    <b-form-textarea
      v-if="columnInfo.visible()"
      v-model="_value"
      :disabled="columnInfo.disable() || disabled"
      :id="columnInfo.domainColumnName"
      :name="columnInfo.domainColumnName"
      :state="(state && validated) || (state && touched) ? passed : null"
      :rows="rows"
      :max-rows="rows"
      no-resize
      v-bind="$attrs"
      v-on="$listeners"
    />
    <span v-if="errorVisible" class="text-danger">
      {{ errors[0] }}
    </span>
  </validation-provider>
</template>

<script>
export default {
  name: 'BaseTextArea',

  inheritAttrs: false,

  props: {
    value: {
      type: String,
      default: '',
    },

    /**
     * 定義情報.
     * @type {Object}
     * @requires
     */
    columnInfo: {
      type: Object,
      required: true,
    },

    /**
     * 入力不可か.
     * @type {Boolean}
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * バリデーションチェックの状態を表示するか.
     * @type {Boolean}
     */
    state: {
      type: Boolean,
      default: false,
    },

    validated: {
      type: Boolean,
      default: true,
    },

    touched: {
      type: Boolean,
      default: true,
    },

    passed: {
      type: Boolean,
      default: false,
    },

    /**
     * 入力検証ルール.
     * @type {String}
     */
    rules: {
      type: Array,
      default: () => [],
    },

    /**
     * エラーメッセージを表示するか.
     * @type {Boolean}
     */
    errorVisible: {
      type: Boolean,
      default: true,
    },

    rows: {
      type: Number,
      default: 6,
    },

    maxLength: {
      type: Number,
      default: -1,
    },

    minLength: {
      type: Number,
      default: -1,
    },
  },

  computed: {
    _value: {
      get() {
        return this.value
      },

      set(v) {
        if (this.value !== v) this.$emit('input', v)
      },
    },

    /**
     * 入力検証ルール.
     * @return {String}
     */
    _rules() {
      let rules = ''
      this.rules.forEach((element) => {
        if (element == this.INPUT_TYPE_CHECK.REQUIRED) {
          rules += 'required|'
        }
        if (element == this.INPUT_TYPE_CHECK.MAXLENGTH) {
          rules += `max:${this.maxLength}|`
        }
        if (element == this.INPUT_TYPE_CHECK.MINLENGTH) {
          rules += `min:${this.minLength}|`
        }
      })
      return rules
    },
  },
}
</script>

<style scoped></style>
